import { ItemTypeModel } from '@entities/ItemType/ItemTypes';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';

export const GetItemTypeById = (
    itemTypeId: number,
    parsedFragments: ParsedFragmentEntity[]
) => {
    const itemTypes = parsedFragments.flatMap(fragment => fragment.itemTypes);
    return (
        itemTypes.find(item => item.id === itemTypeId) ?? new ItemTypeModel()
    );
};
